export default "__VITE_ASSET__3ec62899__"